<div class="tw-flex tw-flex-col tw-h-full">
    <div class="tw-flex tw-items-center tw-gap-0 tw-mb-6 tw-flex-wrap">
        <div class="tw-flex tw-items-center tw-flex-grow">
            <h3 id="leaderboard" class="tw-text-black tw-font-bold tw-font-md">
                {{ name }}
            </h3>
        </div>
        <form [formGroup]="form">
            <div class="tw-min-w-[10rem] tw-max-w-[20rem]">
                <app-form-dropdown-single-select controlName="range" label="Week" [items]="dropdownItems" />
            </div>
        </form>
    </div>

    <!-- Loader - block -->
    <div *ngIf="loading && !leaderboard" class="tw-py-6">
        <app-loader loaderColor="default" loaderSize="s"></app-loader>
    </div>

    <div role="region" aria-live="polite">
        <div role="list" class="relative">
            <div role="listitem" *ngFor="let user of leaderboard; let last = last">
                <app-leaderboard-item class="tw-block" [ngClass]="!last ? 'tw-mb-2' : ''" [user]="user"></app-leaderboard-item>
            </div>

            <!-- Loader - overlay -->
            <app-loader *ngIf="loading && leaderboard" loaderType="cover" overlayColor="white"></app-loader>
        </div>
    </div>
</div>
